import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const validateQR = async (qrCode) => {
  const response = await api.post('/validate-qr', { qrCode });
  return response.data;
};

export const getMenu = async (restaurantId) => {
  const response = await api.get(`/menu/restaurants/${restaurantId}`, {
    params: { context: 'time', _t: Date.now() },
    headers: { 'Cache-Control': 'no-cache' },
  });
  return response.data;
};

export const createOrder = async (orderData) => {
  const response = await api.post('/orders', orderData);
  return response.data;
};

export const getSessionOrders = async (sessionId) => {
  const response = await api.get(`/orders/sessions/${sessionId}`);
  return response.data;
};

export const getOrdersByCustomer = async (phone, limit = 20) => {
  const response = await api.get(`/orders/customer/${encodeURIComponent(phone)}`, {
    params: { limit }
  });
  return response.data;
};

export const verifyLinePayment = async (paymentId, orderId, amount) => {
  const response = await api.post('/payments/verify', { paymentId, orderId, amount });
  return response.data;
};

export const createLinePayment = async (orderId) => {
  const response = await api.post('/payments/line-checkout/create', { orderId });
  return response.data;
};

export const callWaiter = async (requestData) => {
  const response = await api.post('/waiter/call', requestData);
  return response.data;
};

export const requestBill = async (requestData) => {
  const response = await api.post('/waiter/bill', requestData);
  return response.data;
};

export const createSessionPayment = async (data) => {
  const response = await api.post('/payments/session-checkout', data);
  return response.data;
};

export const createMercadoPagoPreference = async (data) => {
  // data: { sessionId, splitMode, payerName, payerId, splitParticipants? }
  // returns: { paymentId, checkoutUrl, amount }
  const response = await api.post('/payments/mercadopago/session-preference', data);
  return response.data;
};

export const verifyMercadoPagoPayment = async (paymentId, sessionId) => {
  const response = await api.post('/payments/mercadopago/verify', { paymentId, sessionId });
  return response.data;
};

export const verifySessionPayment = async (paymentId, sessionId, amount) => {
  const response = await api.post('/payments/session-verify', { paymentId, sessionId, amount });
  return response.data;
};

export const getSessionPayments = async (sessionId) => {
  const response = await api.get(`/payments/sessions/${sessionId}`);
  return response.data;
};

export const resolveCustomDomain = async (hostname) => {
  const response = await api.get('/public/resolve-domain', { params: { hostname } });
  return response.data;
};

export const getNearbyRestaurants = async (organizationId, lat, lng) => {
  const params = { organizationId };
  if (lat !== null && lat !== undefined) params.lat = lat;
  if (lng !== null && lng !== undefined) params.lng = lng;
  const response = await api.get('/restaurants/public/nearby', { params });
  return response.data;
};

export const resolveSlug = async (slug, organizationId) => {
  const response = await api.get('/restaurants/public/resolve-slug', {
    params: { slug, organizationId }
  });
  return response.data;
};

export const estimateDeliveryFee = async (restaurantId, lat, lng) => {
  const response = await api.post('/orders/estimate-delivery-fee', {
    restaurantId,
    lat,
    lng,
  });
  return response.data;
};

export const getRestaurantBranding = async (restaurantId) => {
  try {
    const response = await api.get(`/restaurants/${restaurantId}/branding`);
    return response.data;
  } catch (error) {
    console.warn('Could not load restaurant branding, using defaults:', error.message);
    // Return null to use default branding
    return null;
  }
};

export default api;
